export default "__VITE_ASSET__07bcac1a__"